import {AsyncStatus} from '@yandex-taxi/react-integration-api'
import {useMapLoader} from '@yandex-taxi/react-ymaps'
import {MapQueryParams} from '@yandex-taxi/react-ymaps/build/main/utils/loadYMaps'
import React, {useEffect, useState} from 'react'

import {LoaderContext, LoaderContextType} from './Context'

type Props = {
  query?: MapQueryParams
}

// провайдер из пакета не подошел, потому что нужно было набросить стили, а там это коряво сделано
// надо бы там поправить этот момент
const Loader: React.FC<React.PropsWithChildren<Props>> = ({query, children}) => {
  const {loading, error} = useMapLoader(query)
  const [asyncState, setAsyncState] = useState<LoaderContextType>({
    status: AsyncStatus.PENDING,
  })

  useEffect(() => {
    if (loading) {
      return
    }

    if (error) {
      setAsyncState({
        status: AsyncStatus.ERROR,
        error,
      })

      return
    }

    setAsyncState({
      status: AsyncStatus.SUCCESS,
    })
  }, [error, loading])

  return <LoaderContext.Provider children={children} value={asyncState} />
}

export default Loader
